import { Typography } from '@material-ui/core';
import { Column, Columns, Stack } from '@superdispatch/ui';
import { Alert, Box } from '@superdispatch/ui-lab';
import { DateTime } from 'luxon';
import { formatCurrency } from 'shared/helpers/IntlHelpers';
import { useNotification } from 'shared/layout/notification-stack/data/NotificationAPI';
import { getPastDueTotal } from 'shared/modules/subscription/core/PastDueInvoice';
import {
  useEstimateTaxPrice,
  useSubscription,
} from 'shared/modules/subscription/SubscriptionAPI';
import { LinkButton } from 'shared/routing/Links';
import styled from 'styled-components';

const AlertContainer = styled.div`
  & .MuiAlert-message {
    flex-grow: 1;
  }
`;

export function SubscriptionPaymentAlerts() {
  const paymentFailed = useNotification('subscription_payment_failed');
  const cardExpiring = useNotification('subscription_card_expiring');
  const { billableSeats } = useSubscription();
  const { data: taxPrice } = useEstimateTaxPrice(
    {
      seats_count: billableSeats?.billable_seats,
      include_total_invoice: false,
    },
    { enabled: !!paymentFailed && !!billableSeats?.billable_seats },
  );

  const pastDueTotal = getPastDueTotal(taxPrice?.past_due_invoices);

  if (!paymentFailed && !cardExpiring) {
    return null;
  }

  return (
    <AlertContainer>
      <Stack space="small">
        {!!paymentFailed && (
          <Alert severity="critical">
            <Stack space="xxsmall">
              <Typography variant="body1">
                We couldn&apos;t process your{' '}
                {pastDueTotal > 0 && `${formatCurrency(pastDueTotal)} `}
                payment
              </Typography>
              <Typography>{paymentFailed.message}</Typography>
              <Box paddingTop="xxsmall">
                <LinkButton
                  size="small"
                  variant="neutral"
                  to="/settings/subscription/pay_past_due"
                >
                  Retry Payment
                </LinkButton>
              </Box>
            </Stack>
          </Alert>
        )}

        {!!cardExpiring && (
          <Alert severity="caution">
            <Columns space="small" align="center">
              <Column width="fluid">
                <Stack space="xxsmall">
                  <Typography variant="body1">
                    Your card ending in {cardExpiring.context.card_last4}{' '}
                    expires{' '}
                    {DateTime.fromISO(cardExpiring.context.expires_on, {
                      zone: 'utc',
                    }).toFormat('MMM d')}
                  </Typography>
                  <Typography>{cardExpiring.message}</Typography>
                </Stack>
              </Column>
              <Column width="content">
                <LinkButton
                  size="small"
                  variant="neutral"
                  to="/settings/subscription/edit_card_details"
                >
                  Update Card
                </LinkButton>
              </Column>
            </Columns>
          </Alert>
        )}
      </Stack>
    </AlertContainer>
  );
}
